import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { ModalController } from '@ionic/angular';
import { FullScreenMediaComponent } from '../modals/full-screen-media/full-screen-media.component';
import { AppService } from './app.service';

export interface FullScreenViewerOptions { 
  image: string, 
  title: string, 
}

@Injectable({
  providedIn: 'root'
})
export class FullScreenViewerService {

  public actionSubject = new Subject<any>();

  public videoPlayerEnabled = false;
  public videoUrl: string;

  constructor(
    private appService: AppService,
    private modalCtrl: ModalController,
  ) { }

  public async openViewer(objects: FullScreenViewerOptions[], index = 0) {
    if (this.appService.isMobile()) {
      this.openFullScreenViewer(objects, index);
    } else {
      this.openOverlayViewer(objects, index);
    }
  }

  public async openFullScreenViewer(objects: FullScreenViewerOptions[], index = 0) {
      // Use modal for mobile (works with modals)
      const modal = await this.modalCtrl.create({
        backdropDismiss: false,
        component: FullScreenMediaComponent,
        cssClass: "fullScreenMediaModal",
        componentProps: {
          images: objects,
          type: "image",
          index: index
        }
      });
      await modal.present();
      const { data } = await modal.onWillDismiss();
  }

  public openOverlayViewer(objects: FullScreenViewerOptions[], index = 0) {
    this.actionSubject.next({data: objects, index: index});
  }

  public getActionSubject(): Subject<any> {
    return this.actionSubject;
  }


}
